import React, { useState } from 'react';
import BookDemoButton from '../../../../../BookDemoButton';
import ContactFormModal from '../ContactFormModal/ContactFormModal';
import './CTA.css';

function CTA() {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
   <>
   <section className="container mb-5 pb-5">
   {/* Sign up CTA */}
   <div className="bg-dark border border-light rounded-3 py-5 px-4 px-sm-0">
     <div className="row justify-content-center py-sm-2 py-lg-5">
       <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10 text-center">
         <h2 className="h1 text-light mb-4">See Orbix in Action</h2>
         <p className="fs-lg text-light opacity-80 pb-4 mb-3">Let's transform your NDT process</p>

         {/* CTA Buttons */}
         <div className="cta-buttons d-flex flex-column flex-sm-row justify-content-center gap-3 mb-3">
           <BookDemoButton label="Book a Demo" id="ctaBookDemo" />
           <button onClick={() => setShowContactModal(true)} className="btn btn-lg btn-outline-primary">Talk to Expert</button>
         </div>
       </div>
     </div>
   </div>
   </section>

   <ContactFormModal show={showContactModal} onClose={() => setShowContactModal(false)} />
   </>
  );
}

export default CTA;

